<template>
  <div v-loading="loading" class="org-users shared-index">
    <h3 class="m-0">Phân quyền menus</h3>
    <el-row class="table-title" type="flex" align="center" justify="space-between">
      <div class="table-title__left">
        <el-tabs value="orgUsers" type="card">
          <el-tab-pane name="orgUsers">
            <div slot="label">
              Danh sách Menus
              <span>({{ total }})</span>
            </div>
          </el-tab-pane>
        </el-tabs>
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          size="small"
          @click="visible = true"
        >Thêm menu mới</el-button>
      </div>
    </el-row>
    <div v-if="!loading" class="table">
      <p v-if="!total">Tổ chức chưa có menus nào</p>
      <div v-else>
        <el-tabs
          v-model="activeMenu"
          tab-position="top"
        >
          <el-tab-pane
            v-for="(menu, index) in allOrgMenus"
            :key="index"
            :label="menu.title"
            :name="menu.type"
          >
          </el-tab-pane>
        </el-tabs>
        <permission
          v-if="selectedMenu"
          :key="activeMenu"
          :menu="selectedMenu"
          :actions="actions"
          :org-menus="oldOrgMenus"
          :org-actions="orgActions"
          :organization="organization"
          :menu-resource="selectedMenuResource"
          @reload="() => handleGetOrganizationActions()"
        />
        <div v-if="selectedMenu">
          <el-divider class="my-2" />
          <el-row type="flex" align="middle" justify="end">
            <el-button type="danger" size="small" @click="() => handleDeleteOrganizationMenu()">
              Xóa Menu
            </el-button>
          </el-row>
        </div>
      </div>
    </div>
    <add-menu-popup
      v-if="visible"
      :visible="visible"
      :org-menus="oldOrgMenus"
      :menus="menus"
      :actions="actions"
      :organization="organization"
      @reload="handleReload"
      @close="visible = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getOrganizationActions, deleteOrganizationAction } from '@/services/organization-action'
import { getActions, getManagedResources } from '@/services/public'
import { getAccountRouters } from '@/utils/filters'
import { updateOrganization } from '@/services/organizations'

import CONSTANTS from '@/config/constants'

const adminMenus = ['home', 'comment', 'organizations', 'user', 'package', 'staff', 'support']

import Permission from './menus/Permission.vue'
import AddMenuPopup from './popups/AddMenu.vue'

export default {
  name: 'OrgMenus',
  components: {
    Permission,
    AddMenuPopup
  },
  props: {
    organization: Object
  },
  data() {
    return {
      loading: true,
      callingAPI: false,
      visible: false,
      actions: [],
      orgActions: [],
      activeMenu: '',
      menus: getAccountRouters().filter((m) => !adminMenus.includes(m.type)),
      menuResources: []
    }
  },
  computed: {
    ...mapGetters(['language']),
    oldOrgMenus() {
      return (this.organization && this.organization.menus ? this.organization.menus.split(',') : []).map((m) => m.trim())
    },
    allOrgMenus() {
      return this.oldOrgMenus.map((m) => this.menus.find((p) => p.type === m)).filter(Boolean)
    },
    total() {
      return this.allOrgMenus.length
    },
    selectedMenu() {
      return this.allOrgMenus.find((m) => m.type === this.activeMenu)
    },
    selectedMenuResource() {
      if (this.selectedMenu) {
        return this.menuResources.find((r) => r.resource_type === this.selectedMenu.type || (this.selectedMenu.apiEndpoint && this.selectedMenu.apiEndpoint === r.endpoint))
      }
      return null
    }
  },
  watch: {
    selectedMenuResource: 'handleGetOrganizationActions',
    'organization.menus': 'loadData'
  },
  beforeMount() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      await Promise.all([
        this.handleGetActions(),
        this.handleGetManagedResources()
      ]).then(async () => {
        this.activeMenu = this.allOrgMenus[0] ? this.allOrgMenus[0].type : null
        this.loading = false
      })
    },
    async handleGetActions() {
      await getActions({}).then((response) => {
        this.actions = CONSTANTS.ACTIONS.map((ac) => {
          const action = response.result.find((a) => a.action_type === ac.key)
          return {
            ...action,
            ...ac
          }
        })
      }).catch(() => {
        this.actions = []
      })
    },
    async handleGetManagedResources() {
      await getManagedResources({ page: 1, per_page: 150 }).then((response) => {
        this.menuResources = this.menus.map((m) => {
          return response.result.find((r) => r.resource_type === m.type || (m.apiEndpoint && m.apiEndpoint === r.endpoint))
        })
      }).catch(() => {
        this.menuResources = []
      })
    },
    async handleGetOrganizationActions() {
      if (this.selectedMenuResource) {
        await getOrganizationActions({ page: 1, per_page: 4, organization_id: this.organization.id, resource_id: this.selectedMenuResource.id }).then(async (response) => {
          this.orgActions = response.result
          if (response.total > 4) {
            await this.deleteOtherActions()
          }
        }).catch(() => {
          this.orgActions = []
        })
      } else {
        this.orgActions = []
      }
    },

    async deleteOtherActions() {
      if (this.selectedMenuResource) {
        await getOrganizationActions({ page: 2, per_page: 4, organization_id: this.organization.id, resource_id: this.selectedMenuResource.id }).then(async (res) => {
          const requests = res.result.map((action) => deleteOrganizationAction(action.id))
          await Promise.all(requests)
          if (res.total > 4) {
            await this.deleteOtherActions()
          }
        })
      }
    },

    async deleteActions() {
      const requests = this.orgActions.map((action) => {
        return deleteOrganizationAction(action.id)
      })
      return Promise.all(requests)
    },

    async handleDeleteOrganizationMenu() {
      this.$confirm('Bạn có chắc chắn muốn xóa không?', 'Xác nhận', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Đóng',
        type: 'warning'
      }).then(async () => {
        this.deleteActions().then(async () => {
          const orgMenus = this.allOrgMenus.filter((m) => m.type !== this.selectedMenu.type)
          await updateOrganization({
            id: this.organization.id,
            menus: orgMenus.map((m) => m.type).join(',')
          })
          this.activeMenu = orgMenus[0] ? orgMenus[0].type : null
          this.$emit('reload')
          this.$notify.success({
            title: 'Thông báo',
            message: 'Xóa menu công.'
          })
        }).catch(() => {
          this.$notify.error({
            title: 'Thông báo',
            message: 'Không thể xóa menu này!'
          })
        })
      })
    },

    async handleReload() {
      await this.$emit('reload')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
